/* eslint-disable */
/**
 * This function register the precision event for mixpanel & posthoc
 * @param {string} country
 * @param {string} eventName
 */

function setMixPanelEvent(country, eventName) {
  console.log(`${country} - New Chekout - ${eventName}`);
  //const mixPanel = window.mixpanel;
  //const postHog = window.posthog;
  //mixPanel.track(`${country} - New Chekout - ${eventName}`);
  //postHog.capture(`${country} - New Chekout - ${eventName}`);
}

export default setMixPanelEvent;
